import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Message from '../../../common/message/Message';
import Heading from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import {
	ONBOARDING_COMPLETE_MESSAGE_TITLE,
	ONBOARDING_COMPLETE_MESSAGE_SUBTITLE,
	ONBOARDING_COMPLETE_MESSAGE_CTA,
} from '../../../../constants/Copy';

import './RegisterIncompleteMessage.scss';

const RegisterIncompleteMessage = ({ onSubmit, firstName }) => {
	return (
		<div className="onboarding-incomplete-message">
			<Heading>
				<Message
					message={ONBOARDING_COMPLETE_MESSAGE_TITLE}
					values={{
						name: firstName ? `, ${firstName}` : '',
					}}
				/>
			</Heading>

			<p className="onboarding__text onboarding-incomplete-message--subtitle">
				{ONBOARDING_COMPLETE_MESSAGE_SUBTITLE}
			</p>

			<Button testId="incomplete-button" onClick={onSubmit}>
				{ONBOARDING_COMPLETE_MESSAGE_CTA}
			</Button>
		</div>
	);
};

RegisterIncompleteMessage.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	firstName: PropTypes.string,
	email: PropTypes.string,
};

RegisterIncompleteMessage.defaultProps = {
	firstName: null,
	email: null,
};

export default connect((state) => ({
	firstName: _.get(state, 'authentication.gigyaUser.profile.firstName'),
	email: _.get(state, 'authentication.gigyaUser.profile.email'),
}))(RegisterIncompleteMessage);
